import type { DemoVideoAttributes } from '../../../types/cms'
import { Container } from '@mui/material'
import { DemoVideoContainer, DemoVideoElement, DemoVideoFrame } from './styles'

const DemoVideo = ({
  placeholder,
  backgroundColour,
  video,
}: DemoVideoAttributes) => {
  const videoUrl = video?.data?.attributes?.url
  const placeholderUrl = placeholder?.data?.attributes?.url
  if (!videoUrl || !placeholderUrl) return null

  return (
    <DemoVideoContainer backgroundColour={backgroundColour ?? '#FFF'}>
      <Container id="demo-video" maxWidth="lg" sx={{ marginBottom: '3rem' }}>
        <DemoVideoFrame>
          <DemoVideoElement
            controls
            poster={placeholderUrl}
            preload="none"
            playsInline
          >
            <source src={videoUrl} />
          </DemoVideoElement>
        </DemoVideoFrame>
      </Container>
    </DemoVideoContainer>
  )
}

export default DemoVideo
